import Card from '@material-ui/core/Card';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import PasswordResetForm from './PasswordResetForm';

const useStyles = makeStyles({
  card: {
    margin: '1rem auto',
    padding: '1.5rem 2rem 1rem 2rem',
  },
});

export default function PasswordReset(): JSX.Element {
  const classes = useStyles();

  return (
    <Container maxWidth="sm">
      <Card className={classes.card}>
        <PasswordResetForm />
      </Card>
    </Container>
  );
}
